import { translate, translateFormatter } from '@/core/localization/translate';
export const countdownDaysLeft = translateFormatter<{
  days: number;
}>([{
  "type": 6,
  "value": "days",
  "options": {
    "=1": {
      "value": [{
        "type": 7
      }, {
        "type": 0,
        "value": " day left"
      }]
    },
    "other": {
      "value": [{
        "type": 7
      }, {
        "type": 0,
        "value": " days left"
      }]
    }
  },
  "offset": 0,
  "pluralType": "cardinal"
}], undefined, undefined, "en");
export const countdownTimeLeft = translateFormatter<{
  hoursFormatted: string;
  minutesFormatted: string;
  secondsFormatted: string;
}>([{
  "type": 1,
  "value": "hoursFormatted"
}, {
  "type": 0,
  "value": "hr "
}, {
  "type": 1,
  "value": "minutesFormatted"
}, {
  "type": 0,
  "value": "m "
}, {
  "type": 1,
  "value": "secondsFormatted"
}, {
  "type": 0,
  "value": "s"
}], undefined, undefined, "en");
export const {
  countdownDays,
  countdownHours,
  countdownMinutes,
  countdownSeconds
} = translate({
  "countdownDays": "DAYS",
  "countdownHours": "HOURS",
  "countdownMinutes": "MINS",
  "countdownSeconds": "SECS"
});